// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"styles_sliderWrapper__3VL2s","slider":"styles_slider__TgFTH","fieldContainer":"styles_fieldContainer__4S9L9"};